/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Image_Export_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Successfully exported {count} images, BDN script, and FCP XML" |
*
* @param {Image_Export_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_success_toast = /** @type {((inputs: Image_Export_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exportation reussie de ${i?.count} images, du script BDN et du XML FCP`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Bilder, BDN-Skript und FCP-XML erfolgreich exportiert`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Immagini ${i?.count}, script BDN e XML FCP esportati correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Изображения ${i?.count}, скрипт BDN и FCP XML успешно экспортированы.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se exportaron con éxito las imágenes ${i?.count}, el script BDN y el XML FCP`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已成功导出 ${i?.count} 图像、BDN 脚本和 FCP XML`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 枚の画像、BDN スクリプト、FCP XML を正常にエクスポートしました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} इमेज, बीडीएन स्क्रिप्ट और एफसीपी एक्सएमएल सफलतापूर्वक निर्यात कर दी गई हैं।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Imagens ${i?.count}, script BDN e XML FCP exportados com sucesso.`)
	return /** @type {LocalizedString} */ (`Successfully exported ${i?.count} images, BDN script, and FCP XML`)
});